<template>
  <div class='labeled-data'>
    <label>{{$props.label}}</label>
    <p>{{$props.data}} <slot></slot></p>
  </div>
</template>

<script>
  export default {
    props: {
      label: String,
      data: [String, Number, Date]
    }
  }
</script>
